/** 素材来源 */
export enum MaterialSource {
  // 未知
  Unknown = 0,
  // Playturbo换肤
  PlayturboTemplate = 1,
  // Playturbo自由编辑
  Playsmart = 2,
  // MWS定制
  MWS = 3,
  // 广告平台上传
  AdPlatform = 4,
}

/** 报表的素材类型（粒度大于CreativeType） */
export enum MaterialType {
  // 未知
  Unknown = 0,
  Graphic = 1, // 图片
  Video = 2, // 视频
  PL = 3, // 试玩
}

/** 渠道 */
export { TrafficType } from '@com/enums/channel'

/** 平台 */
export enum Platform {
  Android = 1,
  IOS = 2,
}

/** 广告类型 */
export enum AdType {
  // 激励视频
  RewardedVideo = 1,
  // 插屏视频
  InterstitialVideo = 2,
}

export enum AdOutputType {
  // 0	other
  // 1	视频+通用endcard
  // 2	视频+动态endcard
  // 3	视频+playable
  // 4	only-video
  // 5	only-playable
  Other = 0,
  VideoAndCommonEndcard = 1,
  VideoAndDynamicEndcard = 2,
  VideoAndPlayable = 3,
  OnlyVideo = 4,
  OnlyPlayable = 5,
}

/** 指标分类 前端自己根据业务进行归类的枚举值 */
export enum MetricsType {
  /** 交互指标 */
  Action,
  /** 转化指标 */
  Translate,
  /** 流失指标 */
  Loss,
  /** 自定义埋点 */
  Custom,
  /** 聚合维度 */
  Breakdowns,
  /** 投放指标 */
  PlaceAds,
}

/** 交互指标 */
export enum Metrics {
  /** 试玩展示 */
  gs = 'p_gs',
  /** 首次交互 */
  fi = 'p_fi',
  /** 试玩结束 */
  ge = 'p_ge',
  /** 有效交互 */
  vi = 'p_vi',
  /** 平均有效交互次数 */
  vi_avg = 'p_vi_avg',
  /** 关闭H5 */
  wc = 'p_wc',
  /** 跳转应用商店 */
  install = 'p_install',
  /** 试玩时跳转数 */
  install_playing = 'p_install_playing',
  /** 试玩结束时跳转数 */
  install_ending = 'p_install_ending',
  /** 重新试玩 */
  replay = 'p_replay',
  /** 首次交互平均时长/毫秒 */
  fi_time = 'p_fi_time',
  /** 试玩平均时长/毫秒 */
  ge_time = 'p_ge_time',
  /** 流失数 */
  loss = 'p_loss',
  /** 交互前流失数 */
  loss_fi = 'p_loss_fi',
  /** 交互后流失数 */
  loss_after_fi = 'p_loss_after_fi',
  /** 试玩时流失数 */
  loss_playing = 'p_loss_playing',
  /** 试玩结束流失数 */
  loss_ending = 'p_loss_ending',
  /** 交互前流失率，0.5表示50%，1表示100% */
  loss_rate = 'p_loss_rate',
  /** 交互前流失率，0.5表示50%，1表示100% */
  loss_fi_rate = 'p_loss_fi_rate',
  /** 交互后流失率，0.5表示50%，1表示100% */
  loss_after_fi_rate = 'p_loss_after_fi_rate',
  /** 试玩时流失率，0.5表示50%，1表示100% */
  loss_playing_rate = 'p_loss_playing_rate',
  /** 试玩结束流失率，0.5表示50%，1表示100% */
  loss_ending_rate = 'p_loss_ending_rate',
  /** 跳转应用商店率，0.5表示50%，1表示100% */
  install_rate = 'p_install_rate',
  /** 试玩时跳转应用商店率，0.5表示50%，1表示100% */
  install_playing_rate = 'p_install_playing_rate',
  /** 试玩结束跳转应用商店率，0.5表示50%，1表示100% */
  install_ending_rate = 'p_install_ending_rate',
  /** 首次交互率，0.5表示50%，1表示100% */
  fi_rate = 'p_fi_rate',
  /** 试玩结束率，0.5表示50%，1表示100% */
  ge_rate = 'p_ge_rate',
  /** 重新试玩率，0.5表示50%，1表示100% */
  rp_rate = 'p_rp_rate',
  /** 到达数 */
  reach = 'p_reach',
  /** 跳转下一场景数 */
  go_next = 'p_go_next',
  /** 跳转下一场景率 */
  go_next_rate = 'p_go_next_rate',
  /** 场景停留平均时长 */
  stay_time = 'p_stay_time',
  /** 用户自定义指标 */
  action1 = 'p_action1',
  action2 = 'p_action2',
  action3 = 'p_action3',
  action4 = 'p_action4',
  action5 = 'p_action5',
  action6 = 'p_action6',
  action7 = 'p_action7',
  action8 = 'p_action8',
  action9 = 'p_action9',
  action10 = 'p_action10',
  /** 自动试玩结束数 */
  ge_auto = 'p_ge_auto',
  /** 手动试玩结束数 */
  ge_manual = 'p_ge_manual',
  /** 自动跳转数 */
  install_auto = 'p_install_auto',
  /** 手动跳转数	 */
  install_manual = 'p_install_manual',
}

// 选择指标包含：消耗、曝光数、点击数、安装数、点击率、安装率、曝光安装率、平均安装成本、平均千次曝光成本、平均点击成本
export enum PlaceAdsMetrics {
  // 消耗
  cost = 'cost',
  // 点击
  click = 'click',
  // 曝光
  impression = 'impression',
  // 安装数
  install = 'install',
  // 点击率
  ctr = 'ctr',
  // 安装率
  cvr = 'cvr',
  // 曝光安装率
  ivr = 'ivr',
  // 平均安装成本
  cpi = 'cpi',
  // 平均千次曝光成本
  cpm = 'cpm',
  // 平均点击成本
  cpc = 'cpc',
  // 日均消耗
  date_cost = 'date_cost',
  // 日均曝光数
  date_impression = 'date_impression',
  // 日均点击数
  date_click = 'date_click',
  // 日均安装数
  date_install = 'date_install',
}

/** 聚合维度 */
// 聚合维度
// period 日期
// traffic_type 渠道
// platform 平台
// country_code 国家
// mid 素材id
// material_name 素材名称
// material_type 素材类型
// ad_type 广告类型
// ad_output_type 广告呈现
// project_id 项目
// product_id 产品
// publish_time 素材生成时间
// project_name 项目名称
// scene 场景
// material_source 素材来源
// template_id 可玩模板
// campaign_id 广告系列
// adset_id 广告计划
// ad_id 广告id 层级关系是 campaign -> adset -> ad 。
// fingerprint Playturbo素材名称
export enum Breakdowns {
  period = 'period',
  day = 'day',
  week = 'week',
  month = 'month',
  traffic_type = 'traffic_type',
  platform = 'platform',
  country_code = 'country_code',
  mid = 'mid',
  mid_source = 'mid_source',
  material_name = 'material_name',
  material_type = 'material_type',
  ad_type = 'ad_type',
  ad_type2 = 'ad_type2',
  ad_output_type = 'ad_output_type',
  project_id = 'project_id',
  product_id = 'product_id',
  publish_time = 'publish_time',
  project_name = 'project_name',
  package_name = 'package_name',
  scene = 'scene',
  material_source = 'material_source',
  template_id = 'template_id',
  campaign_id = 'campaign_id',
  adset_id = 'adset_id',
  ad_id = 'ad_id',
  fingerprint = 'fingerprint',
  basic_id = 'basic_id',
  // playturbo素材名称
  creative_name = 'creative_name',
}
